import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';

@Injectable()
export class AlignResponsesService {
  constructor(private readonly apiService: ApiService) {}

  public getQuestBlocksWithAlignments(): Promise<any> {
    return this.apiService
      .get<any>(`api/rumbles/align-responses/all`)
      .toPromise<any>();
  }

  public getSubmissionsByQuestBlock(questBlockKey): Promise<any> {
    return this.apiService
      .get<any>(`api/rumbles/align-responses/get-by-questblock`, {
        params: {
          questBlockKey: questBlockKey,
        },
      })
      .toPromise<any>();
  }

  public confirmAllUnaligned(questBlockKey): Promise<any> {
    return this.apiService
      .post<any>(`api/rumbles/align-responses/confirm-by-questblock`, {
        quest_block_key: questBlockKey,
      })
      .toPromise<any>();
  }

  public confirmMultipleUnaligned(questBlockKey, submissionIds): Promise<any> {
    return this.apiService
      .post<any>(`api/rumbles/align-responses/confirm-by-submission-ids`, {
        quest_block_key: questBlockKey,
        submission_ids: submissionIds,
      })
      .toPromise<any>();
  }

  public deleteMultipleUnaligned(questBlockKey, submissionIds) {
    return this.apiService
      .post<any>(`api/rumbles/align-responses/delete-by-submission-ids`, {
        quest_block_key: questBlockKey,
        submission_ids: submissionIds,
      })
      .toPromise<any>();
  }

  public deleteAllUnaligned(questBlockKey) {
    return this.apiService
      .post<any>(`api/rumbles/align-responses/delete-by-questblock`, {
        quest_block_key: questBlockKey,
      })
      .toPromise<any>();
  }

  public updateResponse(data): Promise<any> {
    return this.apiService
      .post<any>(`api/rumbles/align-responses/update-response`, data)
      .toPromise<any>();
  }
}
